export const products = [
  // ─── VAPES ───────────────────────────────────────────────────────────────
  {
    id: 1,
    name: 'Lost Mary BM600 Blueberry Ice',
    category: 'vapes',
    price: 5.99,
    originalPrice: null,
    badge: 'Best Seller',
    badgeColor: '#e05c3a',
    mg: '20mg Nicotine',
    effect: 'Cool & Smooth',
    effectColor: '#4a7c59',
    onset: 'Instant',
    rating: 4.8,
    reviews: 312,
    description: "The UK's most loved disposable vape. Icy blueberry hit with 600 puffs and a satisfying throat hit.",
    image: 'https://www.vapeshop.co.uk/cdn/shop/files/lost-mary-bm600-triple-berry-ice_6c120681-842e-462a-82a0-4e06cddc8d7c.png?height=1000&v=1780498245&width=1000',
    gradient: 'linear-gradient(135deg, #e8f0ff 0%, #99b4f0 100%)',
  },
  {
    id: 2,
    name: 'Elf Bar 600 Strawberry Raspberry',
    category: 'vapes',
    price: 5.99,
    originalPrice: null,
    badge: 'Top Rated',
    badgeColor: '#5a6fa0',
    mg: '20mg Nicotine',
    effect: 'Fruity',
    effectColor: '#e0953a',
    onset: 'Instant',
    rating: 4.9,
    reviews: 541,
    description: 'Sweet strawberry and tart raspberry in a sleek disposable. 600 puffs of pure fruity satisfaction.',
    image: 'https://www.elfbar.co.uk/media/catalog/product/cache/00f9a4343dde0ea1b26620c570b41407/e/l/elfbar_600_pod_kit_-_strawberry-raspberry-cherry-ice_1.jpg',
    gradient: 'linear-gradient(135deg, #ffe8e8 0%, #ff9999 100%)',
  },
  {
    id: 3,
    name: 'Crystal Pro Max 10000',
    category: 'vapes',
    price: 12.99,
    originalPrice: 15.99,
    badge: 'Sale',
    badgeColor: '#e05c3a',
    mg: '20mg Nicotine',
    effect: 'Long Lasting',
    effectColor: '#6b9e7a',
    onset: 'Instant',
    rating: 4.7,
    reviews: 198,
    description: 'Up to 10,000 puffs with a rechargeable battery. Tropical Mango flavour with massive clouds.',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTbOhYCz8eTIRxEug-WftJquBdWyV0h8bkTCA&s',
    gradient: 'linear-gradient(135deg, #fff9e6 0%, #ffd580 100%)',
  },
  {
    id: 21,
    name: 'Geek Bar Pulse 15000',
    category: 'vapes',
    price: 14.99,
    originalPrice: 18.99,
    badge: 'New',
    badgeColor: '#4a7c59',
    mg: '20mg Nicotine',
    effect: 'Cool & Smooth',
    effectColor: '#4a7c59',
    onset: 'Instant',
    rating: 4.8,
    reviews: 224,
    description: 'Up to 15,000 puffs with dual-mode output. Cool mint blend for all-day smoothness.',
    image: 'https://www.vapeshop.co.uk/cdn/shop/files/lost-mary-bm600-triple-berry-ice_6c120681-842e-462a-82a0-4e06cddc8d7c.png?height=1000&v=1780498245&width=1000',
    gradient: 'linear-gradient(135deg, #e0f7fa 0%, #80deea 100%)',
  },

  // ─── PODS ─────────────────────────────────────────────────────────────────
  {
    id: 4,
    name: 'SMOK Nord 5 Pod Kit',
    category: 'pods',
    price: 34.99,
    originalPrice: 42.99,
    badge: 'New',
    badgeColor: '#4a7c59',
    mg: 'Kit Only',
    effect: 'Refillable',
    effectColor: '#4a7c59',
    onset: 'Instant',
    rating: 4.8,
    reviews: 174,
    description: 'Powerful refillable pod system with adjustable wattage up to 80W. Includes two mesh coils.',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSbEpHcjRQioF0Ox5Z8paPXSJguT5lpdMLycA&s',
    gradient: 'linear-gradient(135deg, #e8f5e9 0%, #a8d5b5 100%)',
  },
  {
    id: 5,
    name: 'Vaporesso XROS 3 Pod',
    category: 'pods',
    price: 24.99,
    originalPrice: null,
    badge: 'Lab Verified',
    badgeColor: '#1a3a2a',
    mg: 'Kit Only',
    effect: 'MTL Draw',
    effectColor: '#5a6fa0',
    onset: 'Instant',
    rating: 4.7,
    reviews: 203,
    description: 'Ultra-slim pod device with adjustable airflow and auto-draw. Perfect for nic salts.',
    image: 'https://vapebar.pk/wp-content/uploads/2023/01/VAPORESSO-XROS-3-POD-SYSTEM-KIT-SKY-BLUE.jpg',
    gradient: 'linear-gradient(135deg, #f3e8ff 0%, #c8a8f0 100%)',
  },
  {
    id: 6,
    name: 'Nic Salt Bundle — Mango Ice 10ml x5',
    category: 'pods',
    price: 18.99,
    originalPrice: 24.99,
    badge: 'Save 20%',
    badgeColor: '#c9a84c',
    mg: '20mg Nic Salt',
    effect: 'Smooth Hit',
    effectColor: '#e0953a',
    onset: 'Instant',
    rating: 4.6,
    reviews: 88,
    description: 'Five 10ml Mango Ice nic salt bottles. Smooth on the throat, big on flavour. UK compliant.',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQW-yRniVhxad5zrDNRKlBACtf5n-xaoaHXBA&s',
    gradient: 'linear-gradient(135deg, #fff9e6 0%, #ffe4a0 100%)',
  },
  {
    id: 22,
    name: 'Uwell Caliburn G3 Pod Kit',
    category: 'pods',
    price: 28.99,
    originalPrice: 34.99,
    badge: 'Best Seller',
    badgeColor: '#e05c3a',
    mg: 'Kit Only',
    effect: 'MTL Draw',
    effectColor: '#5a6fa0',
    onset: 'Instant',
    rating: 4.9,
    reviews: 310,
    description: 'The Caliburn series keeps getting better. G3 delivers consistent hits with the iconic leak-free design.',
    image: 'https://vapebar.pk/wp-content/uploads/2023/01/VAPORESSO-XROS-3-POD-SYSTEM-KIT-SKY-BLUE.jpg',
    gradient: 'linear-gradient(135deg, #fce4ec 0%, #f48fb1 100%)',
  },

  // ─── SHISHA ───────────────────────────────────────────────────────────────
  {
    id: 7,
    name: 'Al Fakher Double Apple 250g',
    category: 'shisha',
    price: 14.99,
    originalPrice: null,
    badge: 'Classic',
    badgeColor: '#1a3a2a',
    mg: '0.5% Nicotine',
    effect: 'Aromatic',
    effectColor: '#4a7c59',
    onset: '5 min',
    rating: 4.9,
    reviews: 421,
    description: "The iconic Double Apple — sweet red apple and anise blend. The world's most recognised shisha flavour.",
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrJRhOnfNLwS_iGY8029wMCGeF3FVwLimnUQ&s',
    gradient: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
  },
  {
    id: 23,
    name: 'Adalya Love 66 Shisha 200g',
    category: 'shisha',
    price: 12.99,
    originalPrice: null,
    badge: 'Top Rated',
    badgeColor: '#5a6fa0',
    mg: '0.5% Nicotine',
    effect: 'Fruity',
    effectColor: '#e0953a',
    onset: '5 min',
    rating: 4.8,
    reviews: 287,
    description: 'Creamy strawberry cheesecake vibes in every cloud. Adalya Love 66 is a dessert shisha icon.',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrJRhOnfNLwS_iGY8029wMCGeF3FVwLimnUQ&s',
    gradient: 'linear-gradient(135deg, #fce4ec 0%, #ef9a9a 100%)',
  },
  {
    id: 24,
    name: 'Fumari Ambrosia 100g',
    category: 'shisha',
    price: 9.99,
    originalPrice: 13.99,
    badge: 'Sale',
    badgeColor: '#e05c3a',
    mg: '0.5% Nicotine',
    effect: 'Cool & Smooth',
    effectColor: '#4a7c59',
    onset: '5 min',
    rating: 4.7,
    reviews: 165,
    description: 'Light tropical citrus blend. Fumari Ambrosia burns cool and slow for long sessions.',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrJRhOnfNLwS_iGY8029wMCGeF3FVwLimnUQ&s',
    gradient: 'linear-gradient(135deg, #fff9e6 0%, #ffd54f 100%)',
  },
  {
    id: 25,
    name: 'Starbuzz Blue Mist 250g',
    category: 'shisha',
    price: 16.99,
    originalPrice: null,
    badge: 'Premium',
    badgeColor: '#1a3a2a',
    mg: '0.5% Nicotine',
    effect: 'Aromatic',
    effectColor: '#4a7c59',
    onset: '5 min',
    rating: 4.6,
    reviews: 198,
    description: "Starbuzz's cult classic Blue Mist — refreshing sweet blueberry mint. Huge clouds every time.",
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrJRhOnfNLwS_iGY8029wMCGeF3FVwLimnUQ&s',
    gradient: 'linear-gradient(135deg, #e3f2fd 0%, #90caf9 100%)',
  },

  // ─── FLOWER ───────────────────────────────────────────────────────────────
  {
    id: 8,
    name: 'Sour Space Candy — 3.5g',
    category: 'flower',
    price: 19.99,
    originalPrice: null,
    badge: 'Best Seller',
    badgeColor: '#e05c3a',
    mg: '18% THCA',
    effect: 'Uplifting',
    effectColor: '#4a7c59',
    onset: 'Instant',
    rating: 4.8,
    reviews: 312,
    description: 'Indoor-grown THCA hemp flower with a tangy, tropical profile. Dense cured buds, full terpene expression.',
    image: 'https://images.unsplash.com/photo-1574482620811-1aa16ffe3c82?w=800&q=80',
    gradient: 'linear-gradient(135deg, #e8f5e9 0%, #a5d6a7 100%)',
  },
  {
    id: 9,
    name: 'Jealousy — 7g',
    category: 'flower',
    price: 34.99,
    originalPrice: 44.99,
    badge: 'Sale',
    badgeColor: '#e05c3a',
    mg: '22% THCA',
    effect: 'Relaxing',
    effectColor: '#5a6fa0',
    onset: 'Instant',
    rating: 4.9,
    reviews: 541,
    description: 'Heavy indica-leaning THCA strain. Rich cream and fuel terpenes, perfect for evening wind-down.',
    image: 'https://images.unsplash.com/photo-1574482620811-1aa16ffe3c82?w=800&q=80',
    gradient: 'linear-gradient(135deg, #f3e5f5 0%, #ce93d8 100%)',
  },
  {
    id: 10,
    name: 'Hawaiian Haze — 3.5g',
    category: 'flower',
    price: 17.99,
    originalPrice: null,
    badge: 'New',
    badgeColor: '#4a7c59',
    mg: '16% THCA',
    effect: 'Uplifting',
    effectColor: '#e0953a',
    onset: 'Instant',
    rating: 4.7,
    reviews: 198,
    description: 'Sun-cured sativa-dominant hemp with tropical mango and pineapple terpenes. Daytime favourite.',
    image: 'https://images.unsplash.com/photo-1574482620811-1aa16ffe3c82?w=800&q=80',
    gradient: 'linear-gradient(135deg, #fff9e6 0%, #ffe082 100%)',
  },
  {
    id: 26,
    name: 'Skywalker OG — 3.5g',
    category: 'flower',
    price: 21.99,
    originalPrice: null,
    badge: 'Lab Verified',
    badgeColor: '#1a3a2a',
    mg: '20% THCA',
    effect: 'Relaxing',
    effectColor: '#5a6fa0',
    onset: 'Instant',
    rating: 4.8,
    reviews: 244,
    description: 'Classic OG Kush cross with earthy pine and lemon. Perfect for stress relief after a long day.',
    image: 'https://images.unsplash.com/photo-1574482620811-1aa16ffe3c82?w=800&q=80',
    gradient: 'linear-gradient(135deg, #e8eaf6 0%, #9fa8da 100%)',
  },

  // ─── ACCESSORIES ──────────────────────────────────────────────────────────
  {
    id: 11,
    name: 'Stainless Steel Hookah Set',
    category: 'accessories',
    price: 49.99,
    originalPrice: 64.99,
    badge: 'Sale',
    badgeColor: '#e05c3a',
    mg: 'N/A',
    effect: 'Long Lasting',
    effectColor: '#6b9e7a',
    onset: 'N/A',
    rating: 4.7,
    reviews: 143,
    description: 'Premium stainless steel hookah with heat management device. Easy to clean, durable, and full kit included.',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQW-yRniVhxad5zrDNRKlBACtf5n-xaoaHXBA&s',
    gradient: 'linear-gradient(135deg, #eceff1 0%, #b0bec5 100%)',
  },
  {
    id: 12,
    name: 'Coconut Shell Charcoal 1kg',
    category: 'accessories',
    price: 8.99,
    originalPrice: null,
    badge: 'Essential',
    badgeColor: '#1a3a2a',
    mg: 'N/A',
    effect: 'Aromatic',
    effectColor: '#4a7c59',
    onset: 'N/A',
    rating: 4.8,
    reviews: 392,
    description: 'Natural coconut shell hookah charcoal. Long-lasting burn, low ash, no chemical taste.',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQW-yRniVhxad5zrDNRKlBACtf5n-xaoaHXBA&s',
    gradient: 'linear-gradient(135deg, #efebe9 0%, #a1887f 100%)',
  },
  {
    id: 27,
    name: 'Pyrex Glass Bowl — Wide Base',
    category: 'accessories',
    price: 12.99,
    originalPrice: null,
    badge: 'New',
    badgeColor: '#4a7c59',
    mg: 'N/A',
    effect: 'Smooth Hit',
    effectColor: '#5a6fa0',
    onset: 'N/A',
    rating: 4.6,
    reviews: 88,
    description: 'Heat-resistant borosilicate glass bowl for hookah. Wide base for even heat distribution and bigger clouds.',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQW-yRniVhxad5zrDNRKlBACtf5n-xaoaHXBA&s',
    gradient: 'linear-gradient(135deg, #e3f2fd 0%, #81d4fa 100%)',
  },
  {
    id: 28,
    name: 'Silicone Hose + Mouthpiece',
    category: 'accessories',
    price: 11.99,
    originalPrice: 15.99,
    badge: 'Save 25%',
    badgeColor: '#c9a84c',
    mg: 'N/A',
    effect: 'Smooth Hit',
    effectColor: '#4a7c59',
    onset: 'N/A',
    rating: 4.7,
    reviews: 201,
    description: 'Food-grade silicone hookah hose with washable inner lining and anti-rust aluminium mouthpiece.',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQW-yRniVhxad5zrDNRKlBACtf5n-xaoaHXBA&s',
    gradient: 'linear-gradient(135deg, #f3e5f5 0%, #ba68c8 100%)',
  },

  // ─── DRINKS (keeping existing categories from old products.js for CategoryPages) ─
  {
    id: 13,
    name: 'Mango Bliss THC Sparkling Water',
    category: 'drinks',
    price: 7.99,
    originalPrice: null,
    badge: 'Best Seller',
    badgeColor: '#e05c3a',
    mg: '10mg Delta-9',
    effect: 'Uplifting',
    effectColor: '#e0953a',
    onset: '15–30 min',
    rating: 4.9,
    reviews: 445,
    description: 'Zero-calorie sparkling mango drink with 10mg hemp-derived Delta-9. Fast-acting nanoemulsion formula.',
    image: 'https://images.unsplash.com/photo-1622597467836-f3e3dce5d876?w=800&q=80',
    gradient: 'linear-gradient(135deg, #fff9e6 0%, #ffd54f 100%)',
  },
  {
    id: 14,
    name: 'Lemon Haze Sparkling Seltzer',
    category: 'drinks',
    price: 7.99,
    originalPrice: null,
    badge: 'New',
    badgeColor: '#4a7c59',
    mg: '5mg Delta-9',
    effect: 'Relaxing',
    effectColor: '#5a6fa0',
    onset: '15–30 min',
    rating: 4.8,
    reviews: 213,
    description: 'Bright lemon citrus with a 5mg dose for a lighter, social buzz. Perfect for day-drinking done right.',
    image: 'https://images.unsplash.com/photo-1622597467836-f3e3dce5d876?w=800&q=80',
    gradient: 'linear-gradient(135deg, #fffde7 0%, #fff176 100%)',
  },
  {
    id: 15,
    name: 'Watermelon Wave THC Drink',
    category: 'drinks',
    price: 8.99,
    originalPrice: 10.99,
    badge: 'Sale',
    badgeColor: '#e05c3a',
    mg: '10mg Delta-9',
    effect: 'Uplifting',
    effectColor: '#e0953a',
    onset: '15–30 min',
    rating: 4.7,
    reviews: 178,
    description: 'Juicy watermelon seltzer with a clean 10mg dose. No sugar, no guilt, just pure summer vibes.',
    image: 'https://images.unsplash.com/photo-1622597467836-f3e3dce5d876?w=800&q=80',
    gradient: 'linear-gradient(135deg, #fce4ec 0%, #ef9a9a 100%)',
  },
  {
    id: 29,
    name: 'Berry Chill Iced Tea',
    category: 'drinks',
    price: 6.99,
    originalPrice: null,
    badge: 'Lab Verified',
    badgeColor: '#1a3a2a',
    mg: '5mg Delta-9',
    effect: 'Relaxing',
    effectColor: '#5a6fa0',
    onset: '15–30 min',
    rating: 4.8,
    reviews: 302,
    description: 'Mixed berry iced tea infused with 5mg hemp Delta-9. Brewed tea base, smooth and refreshing.',
    image: 'https://images.unsplash.com/photo-1622597467836-f3e3dce5d876?w=800&q=80',
    gradient: 'linear-gradient(135deg, #ede7f6 0%, #9575cd 100%)',
  },

  // ─── GUMMIES ──────────────────────────────────────────────────────────────
  {
    id: 16,
    name: 'Midnight Berry Sleep Gummies',
    category: 'gummies',
    price: 24.99,
    originalPrice: null,
    badge: 'Best Seller',
    badgeColor: '#e05c3a',
    mg: '10mg Delta-9 + 5mg CBN',
    effect: 'Relaxing',
    effectColor: '#5a6fa0',
    onset: '30–60 min',
    rating: 4.9,
    reviews: 509,
    description: 'Triple-tested sleep gummies with Delta-9 and CBN. Blueberry, blackberry, and acai flavour. 30-count.',
    image: 'https://images.unsplash.com/photo-1621939514649-280e2ee25f60?w=800&q=80',
    gradient: 'linear-gradient(135deg, #ede7f6 0%, #7e57c2 100%)',
  },
  {
    id: 17,
    name: 'Tropical Daydream Gummies',
    category: 'gummies',
    price: 22.99,
    originalPrice: null,
    badge: 'New',
    badgeColor: '#4a7c59',
    mg: '5mg Delta-9',
    effect: 'Uplifting',
    effectColor: '#e0953a',
    onset: '30–60 min',
    rating: 4.7,
    reviews: 261,
    description: 'Pineapple and mango gummies with a lighter 5mg dose. Great for afternoons when you want to stay functional.',
    image: 'https://images.unsplash.com/photo-1621939514649-280e2ee25f60?w=800&q=80',
    gradient: 'linear-gradient(135deg, #fff9e6 0%, #ffcc80 100%)',
  },
  {
    id: 18,
    name: 'Sour Apple Chill Gummies',
    category: 'gummies',
    price: 26.99,
    originalPrice: 31.99,
    badge: 'Sale',
    badgeColor: '#e05c3a',
    mg: '10mg Delta-9',
    effect: 'Relaxing',
    effectColor: '#4a7c59',
    onset: '30–60 min',
    rating: 4.8,
    reviews: 389,
    description: 'Sour apple coating over a calming 10mg Delta-9 centre. Vegan, gluten-free, third-party tested.',
    image: 'https://images.unsplash.com/photo-1621939514649-280e2ee25f60?w=800&q=80',
    gradient: 'linear-gradient(135deg, #e8f5e9 0%, #81c784 100%)',
  },
  {
    id: 30,
    name: 'Watermelon Sugar Gummies',
    category: 'gummies',
    price: 23.99,
    originalPrice: null,
    badge: 'Lab Verified',
    badgeColor: '#1a3a2a',
    mg: '5mg Delta-9',
    effect: 'Uplifting',
    effectColor: '#e0953a',
    onset: '30–60 min',
    rating: 4.6,
    reviews: 174,
    description: 'Juicy watermelon flavour with a consistent 5mg dose per piece. 20-count resealable pouch.',
    image: 'https://images.unsplash.com/photo-1621939514649-280e2ee25f60?w=800&q=80',
    gradient: 'linear-gradient(135deg, #fce4ec 0%, #f48fb1 100%)',
  },

  // ─── BUNDLES ──────────────────────────────────────────────────────────────
  {
    id: 19,
    name: 'Mind Blown Starter Bundle',
    category: 'bundles',
    price: 49.99,
    originalPrice: 64.99,
    badge: 'Save 15%',
    badgeColor: '#c9a84c',
    mg: 'Mixed',
    effect: 'Relaxing',
    effectColor: '#5a6fa0',
    onset: 'Varies',
    rating: 4.9,
    reviews: 312,
    description: 'The perfect intro to Mind Blown. 1 drink, 1 pack of gummies, and 1 pre-roll. Lab tested. 15% off.',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80',
    gradient: 'linear-gradient(135deg, #fffde7 0%, #ffd54f 100%)',
  },
  {
    id: 20,
    name: 'Chill Night Bundle',
    category: 'bundles',
    price: 59.99,
    originalPrice: 74.99,
    badge: 'Most Popular',
    badgeColor: '#5a6fa0',
    mg: 'Mixed',
    effect: 'Relaxing',
    effectColor: '#5a6fa0',
    onset: 'Varies',
    rating: 4.8,
    reviews: 489,
    description: 'Everything for the perfect chill night. Sleep gummies, Berry Chill iced tea, and Hawaiian Haze flower.',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80',
    gradient: 'linear-gradient(135deg, #ede7f6 0%, #9575cd 100%)',
  },
  {
    id: 31,
    name: 'Weekend Warrior Bundle',
    category: 'bundles',
    price: 74.99,
    originalPrice: 94.99,
    badge: 'Save 15%',
    badgeColor: '#c9a84c',
    mg: 'Mixed',
    effect: 'Uplifting',
    effectColor: '#e0953a',
    onset: 'Varies',
    rating: 4.8,
    reviews: 267,
    description: '4 drinks, 2 gummy packs, and a 3.5g flower eighth. Full weekend sorted. All lab tested.',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80',
    gradient: 'linear-gradient(135deg, #e8f5e9 0%, #66bb6a 100%)',
  },
  {
    id: 32,
    name: 'Gift Box — Premium Selection',
    category: 'bundles',
    price: 89.99,
    originalPrice: 109.99,
    badge: 'Gift Ready',
    badgeColor: '#1a3a2a',
    mg: 'Mixed',
    effect: 'Relaxing',
    effectColor: '#5a6fa0',
    onset: 'Varies',
    rating: 4.9,
    reviews: 133,
    description: 'Beautifully packaged gift box with our top-rated drink, gummies, vape, and flower. Includes a personalised card.',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80',
    gradient: 'linear-gradient(135deg, #fff8e1 0%, #ffca28 100%)',
  },
];

export const effectVibes = ['All', 'Cool & Smooth', 'Fruity', 'Relaxing', 'Uplifting', 'Aromatic', 'Long Lasting', 'Smooth Hit'];
export const categories = ['All', 'vapes', 'pods', 'shisha', 'flower', 'accessories', 'drinks', 'gummies', 'bundles'];